import type { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { baseColumn } from '../../baseColumn';
import type { ColDefFactory, Column } from '../../types';
import { SecurityMarketDataCell } from '../SecurityMarketDataCell';
import { getSecurityMarketDataCellValue, tryReadSecurityMarketDataRow } from '../helpers';
import type { SecurityMarketDataCellValue, SecurityMarketDataColumnParams } from '../types';

export const securityMarketData: ColDefFactory<Column<SecurityMarketDataColumnParams>> = column => ({
  ...baseColumn(column),
  valueGetter: ({ node }: ValueGetterParams<unknown>): SecurityMarketDataCellValue =>
    getSecurityMarketDataCellValue(column, node),
  cellRenderer: (params: ICellRendererParams<unknown, SecurityMarketDataCellValue>) => {
    const row = tryReadSecurityMarketDataRow(column, params.node);
    const priceActions =
      row != null
        ? column.params?.getPriceActions?.({
            params,
            symbol: row.symbol,
            columnParams: column.params,
          })
        : undefined;

    return <SecurityMarketDataCell {...params} priceActions={priceActions} />;
  },
});
